var kontonummer = require('./dist');
module.exports = kontonummer;
